export default __webpack_public_path__ + "assets/finland-flag.png";